import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { UploadItemsFromExcelMutationRequest, UploadItemsFromExcelMutationResponse, UploadItemsFromExcelQueryParams, UploadItemsFromExcel400, UploadItemsFromExcel401, UploadItemsFromExcel403, UploadItemsFromExcel422, UploadItemsFromExcel429, UploadItemsFromExcel500 } from "../types/UploadItemsFromExcel";

/**
 * @link /api/purchase-tenders/v1/upload_items-from-excel
 */

export function useUploadItemsFromExcel <TData = UploadItemsFromExcelMutationResponse, TError = UploadItemsFromExcel400 | UploadItemsFromExcel401 | UploadItemsFromExcel403 | UploadItemsFromExcel422 | UploadItemsFromExcel429 | UploadItemsFromExcel500, TVariables = UploadItemsFromExcelMutationRequest>(params: UploadItemsFromExcelQueryParams, options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, TVariables>,
          client?: Partial<Parameters<typeof client<TData, TError, TVariables>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, TVariables> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, TVariables>({
    mutationFn: (data) => {
      
      return client<TData, TError, TVariables>({
        method: "post",
        url: `/api/purchase-tenders/v1/upload_items-from-excel`,
        data,
        params,
        
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
